<template>
  <v-dialog
    v-model="showDialog"
    width="500"
  >
    <v-card v-if="data">
      <v-card-title class="text-h5 grey lighten-2">
        Mode de Paiement pour {{ data.participant.fullName }}
      </v-card-title>

      <v-card-text>
        <br>
        <br>
        <v-select
          v-model="mode"
          :items="paymentModes"
          :loading="isSaving"
          :disabled="isSaving"
          label="Sélectionner le mode"
          outlined
        >
          <template v-slot:item="{ item }">
            <div
              class="d-flex align-center justify-space-between"
              style="width: 100%"
            >
              <div>
                {{ item.text }}
              </div>
            </div>
          </template>
        </v-select>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          :disabled="isSaving"
          @click="showDialog = false"
        >
          {{ isSaving ? 'Enregistrement ...' : 'Fermer' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      value: Boolean,
      data: Object,
    },
    data: () => ({
      isSaving: false,
      paymentModes: [
        { text: 'Paiement par chèque', value: 'cheque' },
        { text: 'Paiement par virement', value: 'virement' },
      ],
    }),
    computed: {
      showDialog: {
        get () { return this.value },
        set (val) {
          this.$emit('input', val)
        },
      },
      mode: {
        get () { return this.data?.paymentMode },
        set (val) {
          this.update(val)
        },
      },
    },
    methods: {
      update (paymentMode) {
        const userId = this.data.user.id
        this.isSaving = true
        this.$lco.admin
          .updateParticipantPaymentMode({ paymentMode, userId })
          .then(() => {
            this.data.paymentMode = paymentMode
            this.showDialog = false
            this.isSaving = false
          })
          .catch(err => {
            console.log(err)
            this.isSaving = false
          })
      },
    },
  }
</script>
